<!--下拉多选组件-->
<template>
	<span class="selection-body">
		<span style="font-size: .12rem;"min>{{title}}:</span>
		<div class="selection" @mouseleave="showUl = false">
			<input class="hideBar-input" :id="titleId" readonly="true" :value="nowName" :style="getInputBackground" @mouseenter="showUl = true">
			<ul v-show="showUl" class='custom-scrollbar'>
				<li class="selectionli" v-if='showAll' :key="-1" @click.stop="toggleAll"><img :src="getImg(-1)" class="selectionimg" />全选</li>
				<li class="selectionli" v-for="(item,index) in list" :key="index" @click.stop="checkItem(item,index)"><img :src="getImg(item[idKey])"
					 class="selectionimg" />{{getName(item)}}</li>
			</ul>
		</div>
	</span>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {},
		props: {
			showAll: {
				type: Boolean,
				default: true
			},
			title: {
				type: String,
				default: () => {
					return ''
				}
			},
			nameKey: {
				type: String,
				default: 'name'
			},
			idKey: {
				type: String,
				default: 'id'
			},
			list: {
				type: Array,
				default () {
					return []
				}
			},
			autoCheckIdList: {
				type: Array,
				default () {
					return []
				}
			},
			//是否不允许选中
			disable: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				nowCheckIdList: [], //已选中的下标
				showUl: false,
				titleId: randomPkid(),
			}
		},
		created() {},
		mounted() {
			this.nowCheckIdList = this.autoCheckIdList
		},
		destroyed() {},
		computed: {
			getInputBackground() {
				if (!this.showUl) {
					return this.getBackgroudImageStyle('multipleSelection/arrowDown.png')
				}
				return this.getBackgroudImageStyle('multipleSelection/arrowUp.png')
			},
			getBackgroudImageStyle() {
				return resourcesStore.getters.getBackgroudImageStyle
			},
			getColorStyleById() {
				return resourcesStore.getters.getColorStyleById
			},
			nowCheckDataList() {
				return this.list.filter(item => {
					return this.nowCheckIdList.includes(item[this.idKey])
				})
			},
			nowName() {
				if (!isempty(this.list) && this.nowCheckIdList.length == this.list.length) {
					return '全选'
				}
				if (this.nowCheckIdList.length == 0) {
					return this.getName(undefined)
				}
				var nameList = this.nowCheckDataList.map(item => {
					return this.getName(item)
				})
				if (nameList.length > 0) {
					return nameList.join(",")
				} else {
					return this.getName(undefined)
				}
			}
		},
		watch: {
			list(nv, ov) {
				if (!isempty(nv)) {
					this.nowCheckIdList = this.autoCheckIdList
				}
			},
			nowCheckIdList(nv, ov) {
				this.$emit("checkIdList", nv)
			},
			nowCheckDataList(nv, ov) {
				this.$emit("checkDataList", nv)
			},
		},
		methods: {
			getName(item) {
				if (isempty(item)) {
					return '未选中'
				}
				return item[this.nameKey]
			},
			checkItem(item, index) {
				if (this.disable) {
					return
				}
				if (this.nowCheckIdList.includes(item[this.idKey])) {
					this.nowCheckIdList.splice(this.nowCheckIdList.indexOf(item[this.idKey]), 1)
				} else {
					this.nowCheckIdList.push(item[this.idKey])
				}
			},
			getImg(pkid) {
				if (pkid == -1) {
					if (!isempty(this.list) && this.nowCheckIdList.length == this.list.length) {
						return resourcesStore.getters.getResourcesByName("checkBox/checked.png")
					} else {
						return resourcesStore.getters.getResourcesByName("checkBox/unchecked.png")
					}
				}
				if (this.nowCheckIdList.includes(pkid)) {
					return resourcesStore.getters.getResourcesByName("checkBox/checked.png")
				}
				return resourcesStore.getters.getResourcesByName("checkBox/unchecked.png")
			},
			toggleAll() {
				if (this.nowCheckIdList.length == this.list.length) {
					//是全选,就全取消
					this.nowCheckIdList = []
					return
				}
				var list = []
				for (var i = 0, len = this.list.length; i < len; i++) {
					list.push(this.list[i][this.idKey])
				}
				this.nowCheckIdList = list
			}
		}
	}
</script>

<style scoped>
	.hideBar-input {
		line-height: 0.28rem;
		height: .28rem;
		text-align: center;
		width: 130px;
		font-size: .12rem;
		padding: 0 .2rem 0 .1rem;
		border: 0;
	}

	.selection-body {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: .12rem;
		padding: 0 .1rem;
	}

	.selection {
		text-align: center;
		width: 1.6rem;
		position: relative;
		margin-left: .1rem;
	}

	.selection>p {
		height: .2rem;
		width: 100%;
		line-height: .2rem;
		text-align: center;
		padding: .02rem 0rem;
		border-radius: .05rem;
		border: .01rem solid #CCCCCC;
		white-space: nowrap;
		overflow: auto;
		font-size: .12rem;
		cursor: pointer;
	}

	.selection>ul {
		position: fixed;
		z-index: 1000;
		background: white;
		list-style: none;
		width: 1.58rem;
		border: solid #CCCCCC .01rem;
		overflow: auto;
		height: auto;
		max-height: 2.5rem;
		border-radius: .05rem;

		/* position: absolute;
		left: 0;
		top: .29rem;
		z-index: 2;
		background: white;
		list-style: none;
		width: 1.6rem;
		border: solid #CCCCCC .01rem;
		overflow: auto;
		height: 2.5rem;
		border-radius: .05rem; */
	}

	.selectionli {
		height: .3rem;
		line-height: .3rem;
		padding: .02rem;
		border-width: .01rem 0 0 0;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		white-space: nowrap;
		overflow: hidden;
		cursor: pointer;
		color: black;
	}

	.selectionli:first-of-type {
		border-top: 0;
	}

	.selectionimg {
		width: .12rem;
		height: .12rem;
		margin: 0rem .1rem;
	}

	.selection input {
		/* color: white; */
		/* background-color: rgba(0,0,0,0); */
	}
</style>
